"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateProject = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reduxConnect = require("redux-connect");

var _reactRouter = require("react-router");

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _reduxForm = require("redux-form");

var _Button = require("../../components/form/Button");

var _Button2 = _interopRequireDefault(_Button);

var _ProjectForm = require("../../components/projects/ProjectForm");

var _ProjectForm2 = _interopRequireDefault(_ProjectForm);

var _ProjectSuccessPanel = require("../../components/projects/ProjectSuccessPanel");

var _ProjectSuccessPanel2 = _interopRequireDefault(_ProjectSuccessPanel);

var _projects = require("../../redux/modules/projects");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreateProject = exports.CreateProject = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CreateProject, _Component);

  function CreateProject() {
    (0, _classCallCheck3.default)(this, CreateProject);
    return (0, _possibleConstructorReturn3.default)(this, (CreateProject.__proto__ || (0, _getPrototypeOf2.default)(CreateProject)).apply(this, arguments));
  }

  (0, _createClass3.default)(CreateProject, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.resetCreateProject();
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          user = _props.user,
          company = _props.company,
          projects = _props.projects;

      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Projektit" }),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(
              "h1",
              { className: "h2" },
              company.name,
              ": Uusi projekti"
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            "Yritys : ",
            company.name,
            "  ",
            _react2.default.createElement("br", null),
            "Y-tunnus : ",
            company.business_id,
            " ",
            _react2.default.createElement("br", null)
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            "Nimi :  ",
            user.first_name,
            " ",
            user.last_name,
            "  ",
            _react2.default.createElement("br", null),
            "Puhelinnumero : ",
            user.phone,
            " ",
            _react2.default.createElement("br", null),
            "S\xE4hk\xF6posti: ",
            user.email,
            "  ",
            _react2.default.createElement("br", null)
          )
        ),
        this.defineContent()
      );
    } // end render header

    // render form 

  }, {
    key: "defineContent",
    value: function defineContent() {
      var _props2 = this.props,
          projects = _props2.projects,
          values = _props2.values;


      if (this.props.projects.createProjectSuccess) {
        var transfer_request = this.props.fields.transfer_request;
        var ad_type = this.props.fields.ad_type;

        return _react2.default.createElement(_ProjectSuccessPanel2.default, {
          pushRoute: this.props.pushRoute,
          resetState: this.props.resetCreateProject,
          project: this.props.projects.newProject
        });
      }

      return _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(_ProjectForm2.default, (0, _extends3.default)({
          editing: false,
          submitProject: this.props.createProject
          //       loading={this.props.ads.createProjectLoading || false}
        }, this.props)),
        this.renderErrorMessage()
      );
    }
  }, {
    key: "renderErrorMessage",
    value: function renderErrorMessage() {
      /*
      const { createAdError } = this.props.ads;
      if (createAdError) {
      return (
        <div className="col col-xs-12 col-md-6 col-md-offset-6">
          <p className="error-message error-message-js">
            Ilmoituksen lisäämisessä tapahtui virhe. Yritä myöhemmin uudelleen.
          </p>
        </div>
      );
      }
      */
    }
  }, {
    key: "handleCreateProjectButtonClick",
    value: function handleCreateProjectButtonClick() {

      /*
      this.props.resetState();
      if (this.props.supplierAd) {
        this.props.pushRoute('/ilmoitukset/vastaanotettavat');
      } else {
        this.props.pushRoute('/ilmoitukset/tarjottavat');
      }
      */
    }
  }]);
  return CreateProject;
}(_react.Component), _class.propTypes = {
  user: _react.PropTypes.object,
  handleSubmit: _react.PropTypes.func.isRequired,
  company: _react.PropTypes.object,
  createProject: _react.PropTypes.func.isRequired,
  resetCreateProject: _react.PropTypes.func.isRequired,
  projects: _react.PropTypes.object,
  pushRoute: _react.PropTypes.func.isRequired

}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    company: state.company.company,
    projects: state.projects

  };
}, {
  //   createAd,
  createProject: _projects.createProject,
  resetCreateProject: _projects.resetCreateProject,
  pushRoute: _reactRouterRedux.push
})((0, _reduxForm.reduxForm)({
  form: "createProject",
  fields: ["user_id", "construction_site_id", "company_id", "business_name", "project_owner_name", "business_email", "name", "project_description", "phone_number", "contractor", "site_address",
  // 'construction_site_id',
  "site_address", "postal_area", "postal_code", "contact_person_name", "contact_person_phone", "contact_person_email", "active"],
  // validate: adFormValidator,
  initialValues: {
    active: true

  }
})(CreateProject));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Projects/CreateProject.js
 ** module id = 1232
 ** module chunks = 0
 **/